import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconOldPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 1C4.77614 1 5 1.22386 5 1.5V3.49982C5.41783 3.18597 5.9372 3 6.5 3H17.5C18.8807 3 20 4.11929 20 5.5V17.5C20 19.9853 17.9853 22 15.5 22H8.5C6.01472 22 4 19.9853 4 17.5V1.5C4 1.22386 4.22386 1 4.5 1ZM16 7H8V13H16V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldPhone;
